import CircleType from 'circletype';

const $ = jQuery;
const $window = $(window);

const initCount = () => {
  const els = once('init-count', '.pli-wrapper');
  els.forEach((el) => {
    const childCount = $(el).children('.pli-col').length;
    $('.p-large-icons').addClass(`count-${childCount}`);
  });
};

const initCountIcons = () => {
  const els = once('init-count-icons', '.p-text-box--column-icons');
  els.forEach(() => {
    new CircleType(document.getElementById('ptb-service-msg'))
      .dir(-1)
      .radius(120);
  });
};

$window.on('load', function () {
  initCount();
  initCountIcons();
});
